﻿export class PostDetailsPage {
    public static imageReplacement($: JQueryStatic): void {
        const imgSrc = $(".post-details .post-hero-image-widget img").attr(
            "src"
        );
        const url = "url(" + imgSrc + ")";

        $(".post-details__hero>.col-md-6:nth-of-type(1)").css(
            "background",
            url
        );
    }
}
